import { gql } from '@apollo/client/core'
import { vendorFragment } from '../products/fragments'

export const designChallengeFragment = gql`
  ${vendorFragment}
  fragment DesignChallengeProps on DesignChallenge {
    id
    bannerDesktopImageUrl
    bannerMobileImageUrl
    bannerPrompt
    prompt
    votingUrl
    termsAndConditions
    startAt
    endAt
    status
    vendor {
      ...VendorFields
      logoUrl
    }
    mockup {
      id
    }
  }
`

export const designChallengeSubmissionFragment = gql`
  fragment DesignChallengeSubmissionProps on DesignChallengeSubmission {
    id
  }
`
